import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Modern Tech">
                            <h2>Adjusting To The Changing Modern Demands With Emerging Technologies For Businesses</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>Emerging technologies, otherwise termed modern technologies, have transformed how the world
                            functions. From working to consuming the content to studying – everything has changed –
                            thanks to incredible technological advancements.</p>
                        <p>It is significant to adjust to the changing demands of the modern world to create an
                            impactful digital presence and build the ideal solutions that enable execution. TekRevol
                            ensures the delivery of sustainable and integrated technology solutions that distinguish
                            your business.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;